export default __webpack_public_path__ + "static/media/Operating system-bro.83899600.png";